import $ from "jquery";

(function ($) {
    $(function() {
        const $brandCheckboxes = $('.dropdown-check-list input[type="checkbox"][name="marque[]"]');
        const $carBodyCheckboxes = $('.dropdown-check-list input[type="checkbox"][name="carrosserie[]"]');
        const $motorisationCheckboxes = $('.dropdown-check-list input[type="checkbox"][name="motorisation[]"]');
        const $brandFilters = $('.dropdown-check-list li[data-carrosseries]');
        const $modelFilters = $('.dropdown-check-list li[data-marque]');

        const getSelectedFilters = (filterType) => {
            let $filters = null;
            let selectedFilters = [];

            if(filterType === 'car_body') {
                $filters = $carBodyCheckboxes;
            }
            else if(filterType === 'brand') {
                $filters = $brandCheckboxes;
            }
            else if(filterType === 'motorisation') {
                $filters = $motorisationCheckboxes;
            }
            
            if($filters) {
                const $activeFilters = $filters.filter(':checked');
                
                if($activeFilters.length) {
                    $activeFilters.each((index, filter) => {
                        selectedFilters.push(filter.value);
                    });
                }
            }

            return selectedFilters;
        };
        const refreshFiltersDislay = () => {
            const activeCarBodyFilters = getSelectedFilters('car_body');
            const activeBrandFilters = getSelectedFilters('brand');
            
            $modelFilters.show();
            $brandFilters.show();

            if(activeBrandFilters.length || activeCarBodyFilters.length) {
                let selectorParts = [];

                if(activeBrandFilters.length && activeCarBodyFilters.length) {
                    $brandFilters.hide();
                    $modelFilters.hide();

                    activeCarBodyFilters.forEach((carBodyValue) => {
                        selectorParts.push(`#brand-filter li[data-carrosseries*="${carBodyValue}"]`);
                        
                        activeBrandFilters.forEach((brandValue) => {
                            selectorParts.push(`#model-filter li[data-carrosseries*="${carBodyValue}"][data-marque="${brandValue}"]`);
                        });
                    });
                }
                else if(activeBrandFilters.length && !activeCarBodyFilters.length) {
                    $modelFilters.hide();

                    activeBrandFilters.forEach((brandValue) => {
                        selectorParts.push(`#model-filter li[data-marque="${brandValue}"]`);
                        selectorParts.push(`#brand-filter li`);
                    });
                }
                else if(!activeBrandFilters.length && activeCarBodyFilters.length) {
                    $brandFilters.hide();
                    $modelFilters.hide();

                    activeCarBodyFilters.forEach((carBodyValue) => {
                        selectorParts.push(`#brand-filter li[data-carrosseries*="${carBodyValue}"]`);
                        selectorParts.push(`#model-filter li[data-carrosseries*="${carBodyValue}"]`);
                    });
                }
                
                if(selectorParts.length) {
                    const $filtersValuesToShow = $(selectorParts.join(','));
                    
                    if($filtersValuesToShow.length) {
                        $filtersValuesToShow.show();
                    }
                }
            }
        };

        /** 
         * On car body filter change: 
         * 
         * 1. Get car body filter values
         * 2. Uncheck brand and model filters values which don't correspond to the car body filter values
         * 3. Then display brand and model filters values which match with car body filter values
         */ 
        const onCarBodyFilterChange = (e) => {
            const target = typeof e !== 'undefined' ? e?.target : null;

            // 1
            const activeCarBodyFilters = getSelectedFilters('car_body');
            
            // 2
            let selectorParts = [];
            // Get brand and model filters values which are already checked
            const $activeBrandAndModelFilters = $('#brand-filter input[type="checkbox"]:checked, #model-filter input[type="checkbox"]:checked').not(target);
            // Get brand and model filters values which match with car body filter values
            if(activeCarBodyFilters.length) {
                activeCarBodyFilters.forEach((carBodyValue) => {
                    selectorParts.push(`#brand-filter li[data-carrosseries*="${carBodyValue}"] input[type="checkbox"]`);
                    selectorParts.push(`#model-filter li[data-carrosseries*="${carBodyValue}"] input[type="checkbox"]`);
                });
            }
            // Uncheck brand and model filters values which are not in the maching values
            if(selectorParts.length) {
                const $matchingFiltersValues = $(selectorParts.join(', '));
                
                if($activeBrandAndModelFilters.length) {
                    $activeBrandAndModelFilters.not($matchingFiltersValues).prop('checked', false);
                }
            }

            // 3
            refreshFiltersDislay();
        };

        /** 
         * On brand filter change: 
         * 
         * 1. Get car body and brand filter values
         * 2. Uncheck model filters values which don't correspond to the car body and brand filters values
         * 3. Then display model filters values which match with car body and brand filters values
         */ 
        const onBrandFilterChange = (e) => {
            const target = typeof e !== 'undefined' ? e?.target : null;

            // 1
            const activeCarBodyFilters = getSelectedFilters('car_body');
            const activeBrandFilters = getSelectedFilters('brand');

            // 2
            let selectorParts = [];
            // Get model filters values which are already checked
            const $activeModelFilters = $('#model-filter input[type="checkbox"]:checked').not(target);
            // Get model filters values which match with car body and brand filters values
            if(activeBrandFilters.length && activeCarBodyFilters.length) {
                activeCarBodyFilters.forEach((carBodyValue) => {
                    activeBrandFilters.forEach((brandValue) => {
                        selectorParts.push(`#model-filter li[data-carrosseries*="${carBodyValue}"][data-marque="${brandValue}"] input[type="checkbox"]`);
                    });
                });
            }
            else if(activeBrandFilters.length && !activeCarBodyFilters.length) {
                activeBrandFilters.forEach((brandValue) => {
                    selectorParts.push(`#model-filter li[data-marque="${brandValue}"] input[type="checkbox"]`);
                });
            }
            else if(!activeBrandFilters.length && activeCarBodyFilters.length) {
                activeCarBodyFilters.forEach((carBodyValue) => {
                    selectorParts.push(`#model-filter li[data-carrosseries*="${carBodyValue}"] input[type="checkbox"]`);
                });
            }
            
            // Uncheck model filters values which are not in the maching values
            if(selectorParts.length) {
                const $matchingFiltersValues = $(selectorParts.join(', '));
                
                if($activeModelFilters.length) {
                    $activeModelFilters.not($matchingFiltersValues).prop('checked', false);
                }
            }

            // 3
            refreshFiltersDislay();
        };

        $carBodyCheckboxes.on('change', onCarBodyFilterChange);
        $brandCheckboxes.on('change', onBrandFilterChange);

        // Call these functions on DOMReady in case some checkboxes have been checked because of GET parameters values
        onCarBodyFilterChange();
        onBrandFilterChange();
    });
})(jQuery);